import { useAppSelector } from 'common/hooks/redux'
import { useFetchProceduresQuery } from 'features/Procedure/state/procedure.api'
import { useParams } from 'react-router'
import { ProcedureTypeCode } from 'features/Procedure/state/procedure.type'

export const getNextDrawingElementId = ({
  drawingElements,
  procedureId,
  procedurePosition,
}: {
  drawingElements: { id: string; procedureId?: number }[]
  procedureId: number
  procedurePosition: number
}) => {
  const nextCount = drawingElements.filter((el) => el.procedureId === procedureId).length + 1
  return `${procedurePosition}-${nextCount}`
}

export const useDrawingElementId = () => {
  const { siteId } = useParams<{ siteId: string }>()
  const selectedEncounterUid = useAppSelector(
    (state) => state.procedureReducer.selectedEncounterUid,
  )
  const selectedProcedure = useAppSelector((state) => state.procedureReducer.selectedProcedure)
  const drawingElements = useAppSelector((state) => state.procedureReducer.drawingElements)

  const { data: proceduresData } = useFetchProceduresQuery(
    {
      siteId,
      encounterUid: selectedEncounterUid,
    },
    {
      skip: !selectedEncounterUid || !siteId,
    },
  )

  const generateDrawingElementId = (): string => {
    if (!selectedProcedure) {
      return `${Date.now()}`
    }

    const procedures = (proceduresData?.items || []).filter(
      (item) => item.code_type === ProcedureTypeCode.CPT4,
    )

    const procedureIndex = procedures.findIndex((p) => p.id === selectedProcedure.id)
    const procedurePosition = procedureIndex !== -1 ? procedureIndex + 1 : procedures.length + 1

    return getNextDrawingElementId({
      drawingElements,
      procedureId: selectedProcedure.id,
      procedurePosition,
    })
  }

  return {
    generateDrawingElementId,
  }
}
